equalheight = function(container){

  var currentTallest = 0,
      currentRowStart = 0,
      rowDivs = new Array(),
      $el,
      topPosition = 0;
  $(container).each(function() {

    $el = $(this);
    $($el).height('auto')
    topPostion = $el.position().top;

    if (currentRowStart != topPostion) {
      for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
      rowDivs.length = 0; // empty the array
      currentRowStart = topPostion;
      currentTallest = $el.height();
      rowDivs.push($el);
    } else {
      rowDivs.push($el);
      currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
    }
    for (currentDiv = 0 ; currentDiv < rowDivs.length ; currentDiv++) {
      rowDivs[currentDiv].height(currentTallest);
    }
  });
}


$(window).load(function() {
  equalheight('.CollaborationsColHeight');//our-story(product-page)
  equalheight('.guide-section .feature-inner');//get help page
  equalheight('.product-wrap .product_image');//collection page page
  equalheight('.thumbnail .title');//collection page page
  equalheight('.press .custom__item');//Press  page
  equalheight('.article h5.sub_title');//Press related page
  equalheight('.blog_article');//blog list page 
  equalheight('.blog_article h2');//blog list page
  equalheight('.all_content_article');//Article list page  
  equalheight('.article .article_title');//Article list page  
  equalheight('.article > a.article_blog_image');//Article image
  equalheight('.featured-blog-section .article h3.sub_title');//Article image
  
  equalheight('.product-list .item');//product listing
  equalheight('#shopify-section-search-template .sub_title');//Search listing
  equalheight('.search-main-images');//search image listing
});

$(window).resize(function(){
  
  equalheight('.guide-section .feature-inner');
  equalheight('.product-wrap .product_image');
  equalheight('.thumbnail .title');
  equalheight('.press .custom__item');
  equalheight('.article h5.sub_title');
  equalheight('.blog_article');
  equalheight('.blog_article h2');
  equalheight('.all_content_article');
  equalheight('.article .article_title');
  equalheight('.article > a.article_blog_image');
  equalheight('.featured-blog-section .article h3.sub_title');//Article image
  equalheight('.product-list .item');//product listing
  equalheight('#shopify-section-search-template .sub_title');//Search listing
  equalheight('.search-main-images');//search image listing
  //equalheight('.CollaRowList:nth-child(even) .CollaborationsColHeight');
});	
// jQuery(document).ready

